import { render } from "./NavbarComp.vue?vue&type=template&id=36a98a4f"
import script from "./NavbarComp.vue?vue&type=script&lang=js"
export * from "./NavbarComp.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/BNRY-technical-assessment/BNRY-technical-assessment/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__